import produce from 'immer';

import * as actionTypes from './actionTypes';

const settingsReducer = defaultState =>
  produce((draft, { type, payload }) => {
    let newState = draft;
    switch (type) {
      case actionTypes.SET_SETTING:
        newState[payload.key] = payload.value;
        break;
      default:
    }
  }, defaultState);

export default settingsReducer;
